import handleResponse from "../../../shared/handleResponse";
import { AppThunk, AppDispatch } from "../../types";
import { SET_AUTH } from "..";

type CreateSessionProps = { email: string; password: string };
export type CreateSession = (credentials: CreateSessionProps) => void;

type CreateSessionSuccessParams = { jwt: string; role: string };

const createSession = ({ email, password }: CreateSessionProps): AppThunk => async (
  dispatch: AppDispatch,
) => {
  const params = { email, password };
  const onSuccess = ({ jwt, role }: CreateSessionSuccessParams) => {
    localStorage.setItem("jwt", jwt);
    dispatch({ type: SET_AUTH, payload: { logged: true, role } });
  };
  await handleResponse("post", "/sessions", onSuccess, dispatch, params);

};

export default createSession;
